import { render, staticRenderFns } from "./cartItem.vue?vue&type=template&id=1fbff8ee&"
import script from "./cartItem.vue?vue&type=script&lang=js&"
export * from "./cartItem.vue?vue&type=script&lang=js&"
import style0 from "./cartItem.vue?vue&type=style&index=0&id=1fbff8ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports